import type { LocalisedDateFn } from '@archipro-website/localisation';

type DateInput = number | string | Date | null | undefined;

export const getFormattedLocalisedDate = (
    localisedFn: LocalisedDateFn,
    date: DateInput,
    format = 'DD MMMM YYYY',
) => {
    // Never fall back to `new Date()`. Doing so renders *today's* date, computed
    // independently on the server and the client, so the two can disagree (e.g.
    // across the NZ/AU midnight boundary) — a server/client text mismatch that
    // bails the route's hydration and re-renders it client-side (React #418),
    // dropping SSR content. This is the same timezone-in-a-serialised-date family
    // as the project-page ld+json fix (BB-3925). A date-less item renders no date.
    if (!date) return undefined;
    return localisedFn(new Date(date))?.format(format);
};
